<template>
    <v-card class="cardBgColorStyle" >

        <v-toolbar dark dense color="tertiary">
            <v-toolbar-title> {{formTitle}} </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn title="關閉視窗" icon dark @click.native="closeCopyDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <v-card-text>
            <v-container grid-list-md style="padding: 0px!important;">

                <v-layout wrap row xs12 sm12 md12>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >院區代號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-select
                                    v-if="this.zoneNameList.length>0"
                                    v-model="zone"
                                    hide-details
                                    :items="zoneNameList"
                                    :item-text="zoneItemText"
                                    item-value="zone"
                            ></v-select>
                            <v-text-field v-else  :rules="[rules.required]"  v-model="zone"  clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >時段*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>

                            <v-select
                                    :rules="[rules.required]"
                                    :items="apnList"
                                    item-value="value"
                                    item-text="apn"
                                    v-model="apn"
                            ></v-select>

                        </v-flex>
                    </v-flex>


                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >診間代號*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-text-field :rules="[rules.required]"   v-model="clinicNo"   clearable></v-text-field>
                        </v-flex>
                    </v-flex>

                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >提示事件類別*</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>

                            <v-select
                                    :rules="[rules.required]"
                                    :items="noteEventList"
                                    item-value="value"
                                    item-text="note"
                                    v-model="noteEvent"
                            ></v-select>

                        </v-flex>
                    </v-flex>



                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >看診日期*  <v-btn @click="addCopy"  dark fab top right color="accent" class="mb-2 mt-0">
                                <v-icon >mdi-plus</v-icon>
                            </v-btn></v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2 text-left>
                            <v-flex xs12 sm12 md12 row wrap row--dense>

                                <v-card
                                        class="mx-auto xs5 sm5 md2 lg2 mx-1 my-1"
                                        v-for="(item,key) in viewDateList" :key="key"
                                        tile
                                >
                                    <v-list  class="v-list--dense">
                                        <v-subheader>看診日期{{key+1}} </v-subheader>

                                        <v-list-item
                                                class="v-list-item--dense"
                                        >
                                            <v-list-item-icon>
                                                <v-btn  title="刪除" icon class="mx-0" @click.native.stop="deleteCopy(item)">
                                                    <v-icon color="tertiary">mdi-delete</v-icon>
                                                </v-btn>
                                            </v-list-item-icon>
                                            <v-list-item-content >
                                                <v-list-item-title >
                                                    <v-text-field  counter="7" :rules="[rules.required,rules.viewDateCounter]"  v-model="item.viewDate"   clearable></v-text-field>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>

                                    </v-list>
                                </v-card>
                            </v-flex>
                        </v-flex>
                    </v-flex>



                    <v-flex xs12 sm12 md12 d-inline-flex>
                        <v-flex xs5 sm5 md2 text-right  class="labelFont">
                            <v-label >提示內容</v-label>
                        </v-flex>
                        <v-flex xs7 sm7 md10 pl-2>
                            <v-textarea  filled rows="4" auto-grow :value="promptNote"  v-model="promptNote"  clearable ></v-textarea>
                        </v-flex>
                    </v-flex>





                </v-layout>


            </v-container>
        </v-card-text>
        <v-card-actions style="margin-bottom: 10px;margin-right: 10px;">
            <v-spacer></v-spacer>
            <v-btn  @click.native="closeCopyDialog">取消</v-btn>
            <v-btn  @click.native="saveCopy">送出</v-btn>
        </v-card-actions>



    </v-card>
</template>

<script>
    export default {
        name: "CopyClinicNoNote",
        props:['editIndex','isShow','zoneNameList'],
        data() {
            return {
                viewDateList:[],
                zone:'',//院區代號
                viewDate:'',//看診日期
                apn:'',//時段
                memo:'',//就醫者註記說明
                clinicNo:'',// 診間代號
                noteEvent:'',// 提示事件類別
                promptNote:'',// 提示內容
                modifyObj:{},
                rules:{
                    required: value => !!value || '必填.',
                    viewDateCounter:value => value!=null && value!=='' && value!==undefined && value.length <= 7 || '最多7個數字',

                },
                apnList:[
                    {apn:'上午診',value:'1'},
                    {apn:'下午診',value:'2'},
                    {apn:'晚上診',value:'3'},
                ],
                noteEventList:[
                    {note:'A-掛號輸入畫面',value:'A'},
                    {note:'B-掛號結果畫面',value:'B'}
                ]
            }
        },
        watch:{
            isShow(val){
                if(val==true){
                    this.zone = 'A'
                    this.apn = ''
                    this.viewDate = ''
                    this.clinicNo = ''
                    this.noteEvent = ''
                    this.promptNote = ''
                    this.viewDateList = [];
                    this.addCopy();
                }

            }
        },
        computed:{
            formTitle () {
                return this.editIndex == -1 ? '新增 診間掛號特別提示' : '新增 診間掛號特別提示'
            },
        },
        methods:{
            deleteCopy(item){
                let index = this.viewDateList.indexOf(item);
                this.viewDateList.splice(index, 1);
            },
            addCopy(){
                this.viewDateList.push({viewDate:''});
            },
            zoneItemText: item => item.zone==''?'':item.zone + '-' + item.zoneName, //格式化 院區顯示文字
            closeCopyDialog(){
                this.$emit('closeCopyDialog');
            },
            saveCopy(){
                let copyList = [];
                if(this.viewDateList.length>0){
                    for(let i in this.viewDateList){
                        copyList.push({
                            zone : this.zone==''||this.zone==null||this.zone==undefined?'':this.zone,
                            apn : this.apn,
                            noteEvent: this.noteEvent,
                            clinicNo: this.clinicNo,
                            promptNote: this.promptNote,
                            viewDate: this.viewDateList[i].viewDate,
                        })
                    }
                }else {
                    alert('請輸入看診日期')
                }


                // parseFloat(this.sortByNo).toFixed(1);
                if(this.zone==''||this.apn==''||this.noteEvent==''||this.clinicNo==''){
                    alert('請確認是否輸入院區代號、看診日期、時段、診間代號、提示事件類別')
                }else {
                    this.$emit('saveCopy',copyList);
                }

            }
        }
    }
</script>

<style scoped>

    .cardBgColorStyle{
        padding:0px 10px;
        background-color: rgba(255,255,255,1);
    }

    .labelFont{
        line-height: 62px;
    }


</style>